import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { DATA_REFRESH_RATE_IN_MILLIS_LONG } from 'src/utils/constants/constants';
import { PricingClient } from 'src/WebApiController';

export function useGetSectionRowScoreRecommendations(
  eventId?: number,
  venueConfigId?: number,
  rowId?: number,
  disabled?: boolean
) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();

  const shouldQuery = useMemo(
    () => Boolean(eventId && venueConfigId && rowId) && !disabled,
    [disabled, eventId, rowId, venueConfigId]
  );
  const scoreRecommendationQuery = useQuery({
    queryKey: ['getSalesByEventId', eventId, venueConfigId, rowId, disabled],
    async queryFn() {
      return await new PricingClient(
        activeAccountWebClientConfig
      ).getScoreSectionRecommendationsByRow(eventId, venueConfigId, rowId);
    },
    enabled: shouldQuery,
    staleTime: Infinity,
    refetchInterval: DATA_REFRESH_RATE_IN_MILLIS_LONG,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('PricingClient.getScoreSectionRecommendationsByRow', error);
      },
    },
  });

  return useMemo(
    () => ({
      selectedSectionRecommendations:
        scoreRecommendationQuery.data ?? undefined,
    }),
    [scoreRecommendationQuery.data]
  );
}
